import React from "react"
// MUI
import {
    Box, Button, Stack, TextField, FormControl, InputLabel, Select, MenuItem, FormHelperText,
} from "@mui/material";
// Data
import {useData} from "@/context/PackagingDataProvider";
// Layout
import {FieldLabel} from "@/components/Layout";
import {packagingTokens as tk} from "@/theme/packagingTokens";
// Assets
// @ts-ignore
// Same label icon as the sidebar's "Brands and Ranges" entry (replaces the old brands.svg asset)
import {SellRounded} from "@mui/icons-material"

export default function RangesEditor(props: any) {

    const {creating, editing, range, setRange, brands, onCreate, onEdit, t} = props
    useData()

    return (
        <Stack spacing={3}>
            {/* Parent brand — a subtle well so the hierarchy reads clearly. */}
            <Box sx={{p: 2, borderRadius: tk.radius.card, backgroundColor: tk.color.bg, border: `1px solid ${tk.color.borderLight}`}}>
                <Stack direction={"row"} spacing={1.5} alignItems={"center"}>
                    <SellRounded sx={{fontSize: 22, color: tk.color.textTertiary, flexShrink: 0}} />
                    <FormControl fullWidth size={"small"}>
                        <InputLabel id={"brand-selector"}>{t("ranges:parent_brand")}</InputLabel>
                        <Select
                            fullWidth
                            label={t("ranges:parent_brand")}
                            labelId={"brand-selector"}
                            onChange={(e) => setRange({...range, brand: e.target.value})}
                            value={range.brand}
                            error={!range.brand}
                        >
                            {!!brands && brands.map((brand: any) => (
                                <MenuItem key={brand.id} value={brand.id}>{brand.name}</MenuItem>
                            ))}
                        </Select>
                        <FormHelperText sx={{display: range.brand ? "none" : "flex"}}>{t("ranges:select_brand_mandatory")}</FormHelperText>
                    </FormControl>
                </Stack>
            </Box>

            <Box>
                <FieldLabel label={t("ranges:range_name")} required />
                <TextField
                    error={range.name === ""}
                    helperText={range.name === "" ? t("ranges:range_name_empty_error") : ""}
                    size="small"
                    variant="outlined"
                    fullWidth
                    value={range.name}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => setRange({...range, name: event.target.value})}
                />
            </Box>

            <Box>
                <FieldLabel label={t("ranges:range_description")} description={t("ranges:range_description_label")} />
                <TextField
                    size="small"
                    variant="outlined"
                    value={range.description}
                    multiline
                    rows={4}
                    fullWidth
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => setRange({...range, description: event.target.value})}
                />
            </Box>

            <Box sx={{display: "flex", justifyContent: "flex-end", pt: 1, borderTop: `1px solid ${tk.color.borderLight}`}}>
                <Button
                    onClick={creating ? onCreate : editing ? onEdit : () => {return}}
                    disabled={range.name === "" || !brands || !range.brand}
                    variant={"contained"}
                    disableElevation
                    sx={{textTransform: "none", fontWeight: 600, borderRadius: tk.radius.sm, px: 2.5}}
                >
                    {creating ? t("ranges:range_create") : editing ? t("ranges:range_edit") : t("common:loading")}
                </Button>
            </Box>
        </Stack>
    )
}
